import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageEventsComponent } from './manage-events/manage-events.component';
import { ManageRegistrationsComponent } from './manage-registrations/manage-registrations.component';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzInputDirective, NzInputGroupComponent } from 'ng-zorro-antd/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import {
  NzFormControlComponent,
  NzFormDirective,
  NzFormLabelComponent,
} from 'ng-zorro-antd/form';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import {
  NzDatePickerComponent,
  NzDatePickerModule,
  NzRangePickerComponent,
} from 'ng-zorro-antd/date-picker';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { RouterModule } from '@angular/router';
import { EventsTableComponent } from './events-table/events-table.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ManageEventsBiddingsComponent } from './manage-events-biddings/manage-events-biddings.component';
import { CurdEventsBiddingsComponent } from './curd-events-biddings/curd-events-biddings.component';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { EventsFeedbackComponent } from './events-feedback/events-feedback.component';
import { ManageForumsComponent } from './manage-forums/manage-forums.component';
import { CrudForumComponent } from './crud-forum/crud-forum.component';
import { CrudEventsComponent } from './crud-events/crud-events.component';
import { ForumTableComponent } from './forum-table/forum-table.component';
import { ManageForumRegistrationsComponent } from './manage-forum-registrations/manage-forum-registrations.component';

@NgModule({
  declarations: [
    ManageEventsComponent,
    ManageRegistrationsComponent,
    EventsTableComponent,
    ManageEventsBiddingsComponent,
    CurdEventsBiddingsComponent,
    EventsFeedbackComponent,
    ManageForumsComponent,
    CrudForumComponent,
    CrudEventsComponent,
    ForumTableComponent,
    ManageForumRegistrationsComponent
  ],
  imports: [
    NzToolTipModule,
    RouterModule,
    CommonModule,
    NzCardComponent,
    NzRowDirective,
    NzSpinComponent,
    NzInputDirective,
    FormsModule,
    NzColDirective,
    NzOptionComponent,
    NzSelectComponent,
    NzFormDirective,
    ReactiveFormsModule,
    NzFormLabelComponent,
    NzDividerComponent,
    NzInputGroupComponent,
    NzDatePickerComponent,
    NzTypographyComponent,
    NzButtonComponent,
    NzIconDirective,
    NzFormControlComponent,
    NzTableModule,
    NzTabsModule,
    NzCheckboxModule,
    NzDropDownModule,
    NzDatePickerModule,
    NzRangePickerComponent,
    NzTagModule,
    RouterModule,
    NzSwitchModule,
    NzUploadModule,
    NzDrawerModule,
    NzRadioModule,
    NzModalModule,
  ],
})
export class EventsModule { }
